import { all } from "redux-saga/effects";
import { tongHopKySaga } from "./tongHopKySaga";
import { tongHopNamSaga } from "./tongHopNamSaga";
import { tongHopToanKhoaSaga } from "./tongHopToanKhoaSaga";

export default function* tongHopDiemSagaWrapper() {
  yield all([
    tongHopKySaga(),
    tongHopNamSaga(),
    tongHopToanKhoaSaga()
  ]);
}
